import React from 'react';
import {useStyles} from "./styles/MemberTableStyle";
import {
    Box,
    Button,
    Typography,
    TextField,
    IconButton,
    FormControl, Select, MenuItem, Dialog,
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import { ReactComponent as ArrowDownIcon } from '../../../common/images/ArrowDownIcon.svg';
import { ReactComponent as DialogCloseIcon } from '../../../common/images/DialogCloseIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {USER_TYPE} from "../../../stores/UserStore";
import {COMMON_UTIL} from "../../../common/util/common.util";
import {displayErrorDialogPrompt} from "../../../common/util/errror/log.util";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function ModifyMember(props) {
    const classes = useStyles();
    const {intl} = props;
    const {userStore, authStore, dialogStore} = props;
    const userType = authStore.getUserType();
    const open = userStore.modifyUserDialogOpen;
    const type = userStore.selectedTab;
    const user = userStore.modifyUser;

    const handleClose = () => {
        userStore.setModifyUserDialogOpen(false);
    }

    const handleChangePassword = (e) => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.password = String(e.target.value).trim();
        userStore.setModifyUser(modifyUser);
    }

    const handleClickRandomPassword = () => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.password = String(Math.floor(1000 + Math.random() * 9000));
        userStore.setModifyUser(modifyUser);
    }

    const handleClickResetPassword = () => {
        userStore.getGroupConfigs(userStore.userDetail.localeGroupId, () => {
            let modifyUser = Object.assign({}, userStore.modifyUser);
            const defaultPasswordConfig = userStore.localeGroupConfigList.find(config => config.configKey === 'DefaultPassword');
            if (defaultPasswordConfig) {
                modifyUser.password = defaultPasswordConfig.value;
                userStore.setModifyUser(modifyUser);
            } else {
                dialogStore.openErrorDialog({
                    titleText: intl.formatMessage({id: "required_group_config"}),
                    text: displayErrorDialogPrompt('', intl.formatMessage({id: "msg_fail_not_exist_group_default_password"}))
                });
            }
        })
    }

    const handleChangeLocaleCode = (e) => {
        const localeCode = e.target.value;
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.localeCode = localeCode;
        modifyUser.localeAdminUserId = ' ';
        modifyUser.localeGroupType = ' ';
        modifyUser.localeGroupId = ' ';
        userStore.setModifyUser(modifyUser);
        if (type !== 'LocaleAdmin') {
            userStore.getLocaleAdminUserIdList(localeCode);
        }
    }

    const handleChangeLocaleAdminUserId = (e) => {
        const localeAdminUserId = e.target.value;
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.localeAdminUserId = localeAdminUserId;
        modifyUser.localeGroupType = ' ';
        modifyUser.localeGroupId = ' ';
        userStore.setModifyUser(modifyUser);

        if (localeAdminUserId === ' ') {
            userStore.setLocaleGroupList([]);
        } else {
            userStore.getLocaleGroupList(localeAdminUserId);
        }
    }

    const handleChangeLocaleGroupType = (e) => {
        const groupType = e.target.value;
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.localeGroupType = groupType;
        modifyUser.localeGroupId = ' ';
        userStore.setModifyUser(modifyUser);
    }

    const handleChangeLocaleGroupName = (e) => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.localeGroupId = e.target.value;
        userStore.setModifyUser(modifyUser);
    }

    const handleChangeEmail = (e) => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.email = String(e.target.value).trim();
        userStore.setModifyUser(modifyUser);
    }

    const handleChangeName = (e) => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        modifyUser.name = String(e.target.value).trim();
        userStore.setModifyUser(modifyUser);
    }

    const handleClickWithdraw = () => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        if (modifyUser.state !== 'Withdraw') {
            modifyUser.state = 'Withdraw';
        } else {
            modifyUser.state = userStore.userDetail.state;
        }
        userStore.setModifyUser(modifyUser);
    }

    const handleClickChangeState = () => {
        let modifyUser = Object.assign({}, userStore.modifyUser);
        if (modifyUser.state === 'Withdraw') {
            if (userStore.userDetail.state === 'Enable') {
                modifyUser.state = 'Disable';
            } else {
                modifyUser.state = 'Enable';
            }
        } else {
            if (modifyUser.state !== userStore.userDetail.state) {
                modifyUser.state = userStore.userDetail.state;
            } else {
                if (modifyUser.state === 'Enable') {
                    modifyUser.state = 'Disable';
                } else {
                    modifyUser.state = 'Enable';
                }
            }
        }
        userStore.setModifyUser(modifyUser);
    }

    const canModify = () => {
        if (userStore.userDetail.state === 'Withdraw') {
            return false;
        }
        return (userStore.canModify() && userStore.isChangeUser());
    }

    const handleClickModifyUser = () => {
        userStore.updateUserDetail(userStore.modifyUser.id, () => {
            handleClose();
            userStore.getUsers(authStore.loginUser.id);
        });
    }

    return (
        <div>
            {user.id ?
                <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} className={classes.dialogWrap}>
                    <Box className={classes.myPageBox}>
                        <Box className={classes.titleDialog} variant="contained" color="primary" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography>{intl.formatMessage({id: "account_management"})}</Typography>
                            <IconButton className={classes.iconButton} disableRipple onClick={handleClose}>
                                <DialogCloseIcon />
                            </IconButton>
                        </Box>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                            <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "member_type"})}</Typography>
                            <Typography className={classes.myPageText}>{intl.formatMessage({id: user.type})}</Typography>
                        </Box>
                        <div>
                            {type === 'LocaleAdmin' &&
                                <div>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>ID</Typography>
                                        <Typography className={classes.myPageTitle}>{user.id}</Typography>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "password"})}<span>*</span></Typography>
                                        <Box className={classes.emailBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "password"})} value={userStore.modifyUser.password} onChange={handleChangePassword} />
                                            <Button className={classes.accountBtn2} disableRipple onClick={handleClickRandomPassword}>
                                                <Typography>{intl.formatMessage({id: "generate_random"})}</Typography>
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={user.localeCode}
                                                onChange={handleChangeLocaleCode}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                    <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "email"})}</Typography>
                                        <Box className={classes.emailBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "email"})} value={user.email !== null ? user.email : ''} onChange={handleChangeEmail}/>
                                        </Box>
                                    </Box>
                                </div>
                            }

                            {type === 'GroupAdmin' &&
                                <div>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>ID</Typography>
                                        <Typography className={classes.myPageTitle}>{user.id}</Typography>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "password"})}<span>*</span></Typography>
                                        <Box className={classes.emailBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "password"})} value={userStore.modifyUser.password} onChange={handleChangePassword} />
                                            <Button className={classes.accountBtn2} disableRipple onClick={handleClickRandomPassword}>
                                                <Typography>{intl.formatMessage({id: "generate_random"})}</Typography>
                                            </Button>
                                        </Box>
                                    </Box>
                                    {userType === USER_TYPE.Admin &&
                                        <>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeCode}
                                                        onChange={handleChangeLocaleCode}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                            <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "LocaleAdmin"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeAdminUserId}
                                                        onChange={handleChangeLocaleAdminUserId}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {user.localeAdminUserId === ' ' &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                                        }
                                                        {userStore.localeAdminUserIdList.length > 0 &&
                                                            userStore.localeAdminUserIdList.map((userId, index) => (
                                                                <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                                            ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </>
                                    }
                                    {userType !== USER_TYPE.GroupAdmin &&
                                        <>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_type"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeGroupType}
                                                        onChange={handleChangeLocaleGroupType}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {user.localeGroupType === ' ' &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group_type"})}</MenuItem>
                                                        }
                                                        {userStore.localeGroupList.length > 0 &&
                                                            userStore.getGroupTypeList().map((type, index) => (
                                                                <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_name"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeGroupId}
                                                        onChange={handleChangeLocaleGroupName}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {user.localeGroupId === ' ' &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group"})}</MenuItem>
                                                        }
                                                        {userStore.localeGroupList.length > 0 &&
                                                            userStore.getGroupList(user.localeGroupType).map((group, index) => (
                                                                <MenuItem key={index} value={group.id}>{group.name}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </>
                                    }
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "email"})}</Typography>
                                        <Box className={classes.emailBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "email"})} value={user.email !== null ? user.email : ''} onChange={handleChangeEmail}/>
                                        </Box>
                                    </Box>
                                </div>
                            }
                            {type === 'Normal' &&
                                <div>
                                    {userType === USER_TYPE.Admin &&
                                        <>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeCode}
                                                        onChange={handleChangeLocaleCode}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {user.localeCode === ' ' &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_locale"})}</MenuItem>
                                                        }
                                                        {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                            <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "LocaleAdmin"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeAdminUserId}
                                                        onChange={handleChangeLocaleAdminUserId}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {(user.localeAdminUserId === ' ') &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                                        }
                                                        {userStore.localeAdminUserIdList.length > 0 &&
                                                            userStore.localeAdminUserIdList.map((userId, index) => (
                                                                <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                                            ))}
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </>
                                    }
                                    {userType !== USER_TYPE.GroupAdmin &&
                                        <>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_type"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeGroupType}
                                                        onChange={handleChangeLocaleGroupType}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {user.localeGroupType === ' ' &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group_type"})}</MenuItem>
                                                        }
                                                        {userStore.localeGroupList.length > 0 &&
                                                            userStore.getGroupTypeList().map((type, index) => (
                                                                <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_name"})}<span>*</span></Typography>
                                                <FormControl className={classes.formControlAccount}>
                                                    <Select
                                                        value={user.localeGroupId}
                                                        onChange={handleChangeLocaleGroupName}
                                                        IconComponent={(props) => (
                                                            <Box>
                                                                <ArrowDownIcon  {...props} />
                                                            </Box>
                                                        )}
                                                        MenuProps={{
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin:{
                                                                vertical: 'top',
                                                                horizontal: 'right',
                                                            },
                                                            getContentAnchorEl: null,
                                                            className:classes.selectPopover
                                                        }}
                                                    >
                                                        {user.localeGroupId === ' ' &&
                                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group"})}</MenuItem>
                                                        }
                                                        {userStore.localeGroupList.length > 0 &&
                                                            userStore.getGroupList(user.localeGroupType).map((group, index) => (
                                                                <MenuItem key={index} value={group.id}>{group.name}</MenuItem>
                                                            ))
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </>
                                    }
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>ID({intl.formatMessage({id: "email"})})<span>*</span></Typography>
                                        <Typography className={classes.myPageText}>{user.id}</Typography>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "password"})}<span>*</span></Typography>
                                        <Box className={classes.emailBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "password"})} value={user.password} onChange={handleChangePassword} />
                                            <Button className={classes.accountBtn2} disableRipple onClick={handleClickResetPassword}>
                                                <Typography>{intl.formatMessage({id: "reset"})}</Typography>
                                            </Button>
                                        </Box>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "name"})}<span>*</span></Typography>
                                        <Box className={classes.emailBox} >
                                            <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "name"})} value={user.name} onChange={handleChangeName}/>
                                        </Box>
                                    </Box>
                                </div>
                            }
                            <Box style={{marginTop: 20}} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "account_state"})}</Typography>
                                <Box sx={{width: 300}} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                    <Typography className={classes.myPageText}>{intl.formatMessage({id: userStore.userDetail.state})}</Typography>
                                    {userStore.userDetail.state !== 'Withdraw' &&
                                        <Box sx={{width: 320}} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                            <Button className={user.state === 'Withdraw' ? classes.accountBtn : classes.accountBtn2} style={{marginRight: 10}} disableRipple onClick={handleClickWithdraw}>
                                                <Typography>{intl.formatMessage({id: "change_withdrawal"})}</Typography>
                                            </Button>
                                            <Button className={(user.state !== 'Withdraw' && userStore.userDetail.state !== user.state) ? classes.accountBtn : classes.accountBtn2} style={{marginRight: 0}} disableRipple onClick={handleClickChangeState}>
                                                <Typography>{userStore.userDetail.state === 'Enable' ? intl.formatMessage({id: "Disable"}) : intl.formatMessage({id: "Enable"})}</Typography>
                                            </Button>
                                        </Box>
                                    }
                                </Box>
                            </Box>
                        </div>
                    </Box>
                    <Box style={{marginBottom: 20, marginRight: 20}} display='flex' justifyContent='flex-end' alignItems='center'>
                        <Button style={{width: 120}} className={canModify() ? clsx(classes.inputButton, classes.inputButtonActive) : classes.inputButton} disableRipple disabled={!canModify()} onClick={handleClickModifyUser}>
                            <Typography>{intl.formatMessage({id: "modify"})}</Typography>
                        </Button>
                        <Button style={{width: 120, marginLeft: 10}} className={clsx(classes.inputButton, classes.inputButtonActive)} disableRipple onClick={handleClose}>
                            <Typography>{intl.formatMessage({id: "confirm"})}</Typography>
                        </Button>
                    </Box>
                </Dialog>
                :
                null
            }
        </div>
    );
}

export default inject('userStore', 'authStore', 'dialogStore')(injectIntl(observer(ModifyMember)));
